import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { DisplayTextPart } from './part';
const b = bemClassBuilder('v-display-text-paragraph');
export const DisplayTextParagraph = observer(({ paragraph, internalActions }) => {
    return (_jsx("p", { className: b.block(), children: paragraph.parts.map((part, index) => (_jsx(DisplayTextPart, { part: part, internalActions: internalActions }, index))) }));
});
DisplayTextParagraph.displayName = 'DisplayTextParagraph';
//# sourceMappingURL=paragraph.js.map